import React from 'react'
import { InputText, InputTextArea } from 'components/atoms'
import { ContentBody, ContentHeader, RowSection, RowSectionTitle, SectionContent } from '../layout'
import DataRow from './DataRow'
import { emptyValue, formatDateTime } from './helpers'
import { IOtaReservation } from 'static/interfaces'
import { IOtaReservationGuestEditor } from 'utils/otaReservation/useGuestEditor'

interface IProps {
  otaReservation: IOtaReservation
  isEditing: boolean
  editor: IOtaReservationGuestEditor
}
const OperationsGuestSectionContent = ({ otaReservation, isEditing, editor }: IProps) => {
  return (
    <SectionContent>
      <ContentHeader>ゲスト情報・その他</ContentHeader>
      <ContentBody>
        <RowSection>
          <RowSectionTitle>ゲスト情報</RowSectionTitle>
          <DataRow label="Guest Name" content={emptyValue(otaReservation.customer_full_name)} />
          <DataRow
            label="人数"
            content={`大人 ${otaReservation.num_of_adults}・子供 ${otaReservation.num_of_children}・幼児 ${otaReservation.num_of_infants}`}
          />
          <DataRow label="国籍" content={emptyValue(otaReservation.customer_country)} />
          <DataRow label="電話番号" content={emptyValue(otaReservation.customer_phone)} />
        </RowSection>
        <RowSection>
          <RowSectionTitle>
            <p>表示名の上書き</p>
            <p className="description">
              OPカレンダー / ガイドアプリ上の表示名を上書きする場合のみ入力
            </p>
          </RowSectionTitle>
          <DataRow
            label="Custom Guest Name"
            content={
              isEditing && editor.customNamesEditable ? (
                <InputText
                  name="custom_guest_name"
                  placeholder="未設定"
                  value={editor.customGuestName}
                  onChangeHandler={event => editor.setCustomGuestName(event.target.value)}
                />
              ) : (
                emptyValue(otaReservation.custom_guest_name)
              )
            }
          />
          <DataRow
            label="Custom Booker Name"
            content={
              isEditing && editor.customNamesEditable ? (
                <InputText
                  name="custom_booker_name"
                  placeholder="未設定"
                  value={editor.customBookerName}
                  onChangeHandler={event => editor.setCustomBookerName(event.target.value)}
                />
              ) : (
                emptyValue(otaReservation.custom_booker_name)
              )
            }
          />
        </RowSection>
        <RowSection className="withBorder">
          <RowSectionTitle>連絡先</RowSectionTitle>
          <DataRow
            label="Email"
            content={
              isEditing && editor.customerDetailsEditable ? (
                <InputText
                  name="customer_email"
                  inputMode="email"
                  placeholder="sample@example.com"
                  value={editor.customerEmail}
                  onChangeHandler={event => editor.setCustomerEmail(event.target.value)}
                />
              ) : (
                emptyValue(otaReservation.customer_email)
              )
            }
          />
          {editor.guestEmails.map(({ email }, index) => (
            <DataRow
              key={`cc-${index}`}
              label={`cc${index + 1}`}
              content={
                isEditing && editor.guestEmailsEditable ? (
                  <InputText
                    name={`cc${index + 1}`}
                    inputMode="email"
                    placeholder="未設定"
                    value={email}
                    onChangeHandler={event => editor.onChangeGuestEmail(index, event.target.value)}
                  />
                ) : (
                  emptyValue(email)
                )
              }
            />
          ))}
        </RowSection>
        <RowSection className="withBorder">
          <RowSectionTitle>その他</RowSectionTitle>
          <DataRow label="Other Requests" content={emptyValue(otaReservation.other_requests)} />
          <DataRow
            label="ガイド公開メモ"
            content={
              isEditing && editor.memoEditable ? (
                <InputTextArea
                  name="memo"
                  value={editor.memo}
                  onChangeHandler={event => editor.setMemo(event.target.value)}
                />
              ) : (
                emptyValue(otaReservation.memo)
              )
            }
          />
          <DataRow
            label="エージェント限定メモ"
            content={
              isEditing && editor.memoEditable ? (
                <InputTextArea
                  name="internal_memo"
                  value={editor.internalMemo}
                  onChangeHandler={event => editor.setInternalMemo(event.target.value)}
                />
              ) : (
                emptyValue(otaReservation.internal_memo)
              )
            }
          />
          {otaReservation.booking_status_id === 'canceled' && (
            <DataRow label="キャンセル理由" content={emptyValue(otaReservation.cancel_reason)} />
          )}
          {otaReservation.canceled_at && (
            <DataRow label="Canceled At" content={formatDateTime(otaReservation.canceled_at)} />
          )}
        </RowSection>
      </ContentBody>
    </SectionContent>
  )
}

export default OperationsGuestSectionContent
